<template >
  <header class="p-3 mb-3 border-bottom header-generico" v-if="isLogin">
    <div class="container">
      <div
        class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start"
      >
        <a class="d-flex align-items-center mb-2 mb-lg-0 text-dark text-decoration-none"
        >
          <img
            src="../assets/logo-azul.png"
            class="bi me-2"
            height="32"
            role="img"
            aria-label="RestoLine"
          />
        </a>
        <ul class="nav col-12 col-lg-auto me-lg-auto mb-2 mb-md-0">
          <li v-for="(opcion, index) in opciones" :key="index">
            <a
              v-if="opcion.url != null"
              :class="{ 'nav-link px-2 link-dark  disabled-link ': !isRestoCompleto,  'nav-link px-2 link-dark ': isRestoCompleto}"
              v-on:click="goToPage(opcion.url)"
              >{{ opcion.name }}</a
            >
            <span
              id="span"
              v-else
              v-on:click="visible(!children.visible)"
              class="nav-link px-2 link-dark"
              >{{ opcion.name }}</span
            >
          </li>
        </ul>
        <br/>
        <br/><br/>
        

        <div class="dropdown text-end">
          <a
          v-on:click="irMiperfil()"
            class="d-block link-dark text-decoration-none dropdown-toggle"
            id="dropdownPerfilUsuario"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              src="../assets/avatar.png"
              alt="mdo"
              width="32"
              height="32"
              class="rounded-circle"
            />
          </a>
          <ul
            class="dropdown-menu text-small"
            aria-labelledby="dropdownPerfilUsuario"
            style=""
          >
            <li><a class="dropdown-item" href="cuenta.html">Mi cuenta</a></li>
            <li>
              <a class="dropdown-item" href="password.html"
                >Modificar contraseña</a
              >
            </li>
            <li>
              <a class="dropdown-item" href="eliminar-cuenta"
                >Eliminar Cuenta</a
              >
            </li>
            <li>
              <hr class="dropdown-divider" />
            </li>
            <li>
              <a class="dropdown-item" href="./">Cerrar sesión</a>
            </li>
          </ul>
        </div>
        <a v-on:click="salir()" class="nav-link px-2 link-dark"
          >Logout</a
        >
      </div>
      <ul class="nav">
          <ul
              class="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0"
              
              v-if="children.visible"
            >
              <li v-for="(child, index) in children.opciones" :key="index">
                <a
                  v-on:click="goToPage(child.url)"
                  class="nav-link px-2 link-dark"
                  >{{ child.name }}</a
                >
              </li>
            </ul>
        </ul>
    </div>
  </header>
</template>
<script>
// @ is an alias to /src
export default {
  props: {
    isRestoCompleto: Boolean
  },
  data: function () {
    return {
      isLogin:false,
      opciones: [
        {
          name: "Datos de Restaurante ↧",
        },
        {
          url: "espera",
          name: "Espera",
        },
        {
          url: "Reservas",
          name: "Ver todas las reservas",
        },
        {
          url: "ReservaManual",
          name: "Ingresar reservas de forma manual",
        },{
          url: "tienda",
          name: "Tienda",
        },{
          url: "miStock",
          name: "Mi Stock de Reservas",
        },{
          url: "misCompras",
          name: "Mis Compras",
        },
        {
          url: "ReporteListaEspera",
          name: "Reportes",
        },
      ],
      children: {
        visible: false,
        opciones: [
          {
            url: "Perfil",
            name: "Perfil",
          },
          {
            url: "Infraestructura",
            name: "Infraestructura",
          },
          {
            url: "Servicios",
            name: "Servicios",
          },
          {
            url: "Especialidades",
            name: "Especialidades",
          },
          {
            url: "RegistrarMesa",
            name: "Registrar Mesa",
          },
          {
            url: "Horarios",
            name: "Horarios",
          },
          {
            url: "Imagenes",
            name: "Imagenes",
          },{
            url: "ImagenesMenu",
            name: "Imagenes Menu",
          },
        ],
      }
    };
  },
  methods: {
    goToPage(page) {
    this.$router.push({ name: page });
    if (page.startsWith('Perfil') || page.startsWith('Infraestructura') || page.startsWith('Servicios') || page.startsWith('Especialidades') || page.startsWith('RegistrarMesa') || page.startsWith('Horarios') || page.startsWith('Imagenes') || page.startsWith('ImagenesMenu')) {
      this.children.visible = true;
    }
  },
    visible(visible) {
      this.children.visible = visible;
    },
    pages() {
    const currentPage = this.$route.name;
    if (currentPage.startsWith('Perfil') || currentPage.startsWith('Infraestructura') || currentPage.startsWith('Servicios') || currentPage.startsWith('Especialidades') || currentPage.startsWith('RegistrarMesa') || currentPage.startsWith('Horarios') || currentPage.startsWith('Imagenes') || currentPage.startsWith('ImagenesMenu')) {
      this.children.visible = true;
    } else {
      this.children.visible = false;
    }
  },
    salir(){
      localStorage.token="";
      this.goToPage('login');
    },
    irMiperfil(){
      this.goToPage('miPerfil');
    },

    parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  },
  },
  
  beforeMount() {

    this.pages();

    let token=localStorage.token;
    if(token!=undefined && token!=null && token!=""){

    let exp=this.parseJwt(token).exp;
    if (Date.now() >= exp * 1000) {
    this.isLogin=false;
  } else{
    this.isLogin=true;
  }}

},

};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

.disabled-link {
  pointer-events: none; /* Desactiva el comportamiento de clic */
  color: #999; /* Aplica un color grisáceo */
  text-decoration: none; /* Elimina la subrayado del link */
  cursor: default; /* Cambia el cursor a "predeterminado" */
}




:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}

body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
}

a {
  cursor: pointer;
}

#span {
  cursor: pointer;
}

</style>
